import { Component, Input, OnInit } from '@angular/core';
import { FormConfig, FormNavigationConfig, DefaultFormConfig } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FamilyFormService } from '../family-form/services/family-form.service';
import { FormConfigUtilityService } from '../services/filterByConfigMetatags/form-config-utility.service';

@Component({
    selector: 'app-load-form',
    templateUrl: './load-form.component.html',
    styleUrls: ['./load-form.component.scss'],
    standalone: false
})
export class LoadFormComponent implements OnInit {

  @Input() formConfigStrategy: string;
  count: number;
  formJson: DefaultFormConfig;

  constructor(
    private formConfigUtility: FormConfigUtilityService,
  ) {

  }

  // Load Config from content storage


  // Modify SEP Build Your Family Form pages to send to next page instead of loop through form.


  // Store the Inputs into Redux


  async ngOnInit() {
    this.formJson = await this.formConfigUtility.getFormConfigFromMap(this.formConfigStrategy);
  }
}
